module.exports = __webpack_public_path__ + "img/landings_en.1d796be2.png";